import React, { memo } from 'react';
import classes from './linkify.module.scss';

export const Linkify = ({ text, targetWord, linkUrl }) => {
	const linkifyText = (text: string, targetWord: string, linkUrl: string): React.ReactNode[] => {
		const splitTexts = text.split(targetWord);
		const result: React.ReactNode[] = [];

		splitTexts.forEach((splitText, index) => {
			result.push(<span key={index}>{splitText}</span>);
			if (index < splitTexts.length - 1) {
				result.push(
					<a key={`link-${index}`} href={linkUrl} target="_brank" rel="noopener noreferrer">
						{targetWord}
					</a>,
				);
			}
		});
		return result;
	};
	return <div>{linkifyText(text, targetWord, linkUrl)}</div>;
};
